import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import DropDownTable from '../../Shared/DropDownTable';
import Input from '../../Shared/Input';
import Button from '../../Shared/Button';
import '../../../css/PreAdvise/AddReefer.css';
import drawer from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-up.svg';
import downarrow from '../../../Assets/ProfileManagement/Assets-Desktop/arrow-down.svg';
import Message from '../../../Data/Shared/Message.json';
import ColorCode from '../../../Data/Shared/ColorCode.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
class AddReefer extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            TempRequired: '',
            VentilationRequired: '',
            O2Required: '',
            CO2Required: '',
            HumidityRequired: '',
            VentilationUnit: '',
            VentilationUnitdropdown: false,
            VentilationUnitdata: [],
            errors: {}
        }
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    OnValidated = () => {
        this.props.history.push("/home");
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ VentilationUnitdropdown: false });
        }
    };
    handleSubmit = () => {
        if (this.handleValidation()) {
            this.OnValidated();
        }
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        if (!this.state.TempRequired) {
            formIsValid = false;
            errors["tempRequired"] = Message.validation.required;
            document.getElementsByName('tempRequired')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('tempRequired')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.VentilationRequired) {
            formIsValid = false;
            errors["ventilationRequired"] = Message.validation.required;
            document.getElementsByName('VentilationRequired')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('VentilationRequired')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.O2Required) {
            formIsValid = false;
            errors["o2Required"] = Message.validation.required;
            document.getElementsByName('O2Required')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('O2Required')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.CO2Required) {
            formIsValid = false;
            errors["co2Required"] = Message.validation.required;
            document.getElementsByName('CO2Required')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('CO2Required')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.HumidityRequired) {
            formIsValid = false;
            errors["humidityRequired"] = Message.validation.required;
            document.getElementsByName('HumidityRequired')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('HumidityRequired')[0].style.borderColor = ColorCode.colorCode.black;
        }
        if (!this.state.VentilationUnit) {
            formIsValid = false;
            errors["ventilationUnit"] = Message.validation.required;
            document.getElementsByName('VentilationUnit')[0].style.borderColor = ColorCode.colorCode.red;
        } else {
            document.getElementsByName('VentilationUnit')[0].style.borderColor = ColorCode.colorCode.black;
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    VentilationUnitdata = [{ name: "1xyz" }, { name: "2xyz" }, { name: "3xyz" }]
    toggleDropdownVentilationUnit = () => {
        this.setState({ VentilationUnitdropdown: !this.state.VentilationUnitdropdown });
        console.log('vvv')
    };
    changeRoleTypeVentilationUnit = (event) => {
        const found = this.VentilationUnitdata?.find((name) => {
            if (name?.name === event?.target?.innerText) {
                return name
            }
        })
        this.setState({ VentilationUnit: found.name });
        this.setState({ VentilationUnitdropdown: !this.state.VentilationUnitdropdown });
        this.setState({
            errors: {
                ...this.state.errors,
                ventilationUnit: ''
            }
        });
        document.getElementsByName('VentilationUnit')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeTempRequired = (e) => {
        this.setState({ TempRequired: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                tempRequired: ''
            }
        });
        document.getElementsByName('tempRequired')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeVentilationRequired = (e) => {
        this.setState({ VentilationRequired: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                ventilationRequired: ''
            }
        });
        document.getElementsByName('VentilationRequired')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeO2Required = (e) => {
        this.setState({ O2Required: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                o2Required: ''
            }
        });
        document.getElementsByName('O2Required')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeCO2Required = (e) => {
        this.setState({ CO2Required: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                co2Required: ''
            }
        });
        document.getElementsByName('CO2Required')[0].style.borderColor = ColorCode.colorCode.black;
    }
    handleChangeHumidityRequired = (e) => {
        this.setState({ HumidityRequired: e.target.value });
        this.setState({
            errors: {
                ...this.state.errors,
                humidityRequired: ''
            }
        });
        document.getElementsByName('HumidityRequired')[0].style.borderColor = ColorCode.colorCode.black;
    }
    render() {
        let drop2 = this.state.VentilationUnitdropdown ? <img src={drawer} /> : <img src={downarrow} />
        return (
            <div class="caacsoutercolor">
                <MetaDecorator title={TitleDescription.addReeferPageTitle} description={TitleDescription.addReeferPageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="caacsnofullAddReefer">
                    <div id="caacsnobox1">
                        <nav class="caacnononavbar">
                            <div className="arcaacnonavbarname">
                                <small id="nonavc">Add Reefer</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="arcaanotificationmaincardAddReefer">
                            <div class="caaoncsdivlow1">
                                <div class="adscsdivlow2">
                                    Enter Reefer Details</div>
                            </div>
                            <div class="caadivup1">
                                <div class="caadivup4AddReefer">
                                    <div class="caadivup55">
                                        <div class="caadivup3AddReefer">
                                            <small id="caaname">Temp. Required (C)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="tempRequired"
                                                    class="input" placeholder="Enter Temp. Required"
                                                    type="text" id="caad06" value={this.state.TempRequired}
                                                    onChange={this.handleChangeTempRequired}
                                                />
                                                <div className="addreefererror1">{this.state.errors["tempRequired"]}</div>
                                            </div>
                                        </div>
                                        <div class="caadivup3AddReefer">
                                            <small id="caaname">Ventilation Required</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="VentilationRequired"
                                                    class="input" placeholder="Enter Ventilation Required"
                                                    type="text" id="caad06" value={this.state.VentilationRequired}
                                                    onChange={this.handleChangeVentilationRequired}
                                                />
                                                <div className="addreefererror1">{this.state.errors["ventilationRequired"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3AddReefer">
                                            <small id="caaname">Ventilation Unit</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    readOnly name="VentilationUnit" class="input" placeholder="Select Ventilation Unit"
                                                    type="text" id="caad066" value={this.state.VentilationUnit}
                                                />
                                                <div className="addreefererror1">{this.state.errors["ventilationUnit"]}</div>
                                                <i id="caainput_imgAddProfile" onClick={this.toggleDropdownVentilationUnit}>{drop2}</i>
                                            </div>
                                            {this.state.VentilationUnitdropdown && (
                                                <div class="caaad08" >
                                                    <div class="caadropdowncard" ref={this.container} >
                                                        {(this.VentilationUnitdata?.map((name, index) => {
                                                            return (
                                                                <DropDownTable onClick={(index1) => this.changeRoleTypeVentilationUnit(index1)}>
                                                                    <small class="pl-3" id="caatt2" >{name?.name} </small>
                                                                </DropDownTable>
                                                            );
                                                        }))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div class="caadivup3AddReefer">
                                            <small id="caaname">Humidity Required (%)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="HumidityRequired"
                                                    class="input" placeholder="Enter Humidity Required"
                                                    type="text" id="caad06" value={this.state.HumidityRequired}
                                                    onChange={this.handleChangeHumidityRequired}
                                                />
                                                <div className="addreefererror1">{this.state.errors["humidityRequired"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="caadivup5">
                                        <div class="caadivup3AddReefer">
                                            <small id="caaname">O2 Required (%)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="O2Required"
                                                    class="input" placeholder="Enter O2 Required"
                                                    type="text" id="caad06" value={this.state.O2Required}
                                                    onChange={this.handleChangeO2Required}
                                                />
                                                <div className="addreefererror1">{this.state.errors["o2Required"]}</div>
                                            </div>
                                        </div>
                                        <div class="caadivup3AddReefer">
                                            <small id="caaname">CO2 Required (%)</small>
                                            <div className="pass-wrapper" id="caad07" >
                                                <Input
                                                    name="CO2Required"
                                                    class="input" placeholder="Enter CO2 Required"
                                                    type="text" id="caad06" value={this.state.CO2Required}
                                                    onChange={this.handleChangeCO2Required}
                                                />
                                                <div className="addreefererror1">{this.state.errors["co2Required"]}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="caabuttdivarzAddReefer">
                                <Button class="caabuttdiv1AddReefer" onClick={this.handleSubmit}>
                                    <small class="caabuttdiv2">Submit</small>
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="caanotifooter01ahz">
                    <Footer />
                </div>
                <div class="caanotifooter02ahz">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default AddReefer;